import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Modal,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";

const MotionBox = motion(Box);
const STORAGE_KEY = "kivunova_christmas_modal_seen";

const ChristmasModal: React.FC = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    // if (!sessionStorage.getItem(STORAGE_KEY)) {
    //   setOpen(true);
    // }
  }, []);

  const handleClose = () => {
    sessionStorage.setItem(STORAGE_KEY, "true");
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          display: "flex",
          alignItems: isMobile ? "flex-end" : "center",
          justifyContent: "center"
        }}
      >
        <MotionBox
          initial={{ opacity: 0, y: isMobile ? 80 : 0, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.5 }}
          sx={{
            width: "100%",
            maxWidth: isMobile ? "100%" : 720,
            maxHeight: "85vh",
            overflowY: "auto",
            borderRadius: isMobile ? "24px 24px 0 0" : 4,
            px: isMobile ? 2.5 : 5,
            py: isMobile ? 3 : 5,
            background: "linear-gradient(135deg, #8B0000, #B11226, #FF3B3B)",
            color: "#fff",
            position: "relative"
          }}
        >
          {/* Close button */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: "#fff",
              backgroundColor: "rgba(255,255,255,0.2)"
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Content */}
          <Box textAlign="center" mt={2}>
            <Typography
              textAlign="center"
              variant={isMobile ? "h5" : "h4"}
              fontWeight={800}
            >
              Merry Christmas
            </Typography>

            <Typography
              variant={isMobile ? "h6" : "h5"}
              mt={0.5}
              textAlign="center"
              fontWeight={700}
            >
              ✨Happy New Year ✨
            </Typography>

            <Typography
              mt={2}
              fontSize={isMobile ? "0.95rem" : "1.05rem"}
              lineHeight={1.6}
              color="#FFF5F5"
            >
              From all of us at <strong>Kivunova</strong>, thank you for being
              part of our journey ❤️ We wish you a season filled with joy, hope,
              and new beginnings. May the coming year bring growth, innovation,
              and success!
            </Typography>

            {/* Emojis */}
            <Box
              mt={3}
              display="flex"
              justifyContent="center"
              gap={1.5}
              fontSize={22}
            >
              🎁 🎄 🎅
            </Box>
          </Box>
        </MotionBox>
      </Box>
    </Modal>
  );
};

export default ChristmasModal;
